<div class="full-w full-h {{ gig?.type || template.type }} image-container" [style.border-radius]="borderRadius">
  <div class="img-text-container" fxLayout="row" fxLayoutAlign="center center" *ngIf="!hideText">
    <span class="img-text" [style.font-size]="textSize">{{ type.translation }}</span>
  </div>
</div>
